<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading d-flex justify-content-between align-items-center">
          <h4 class="my-0">Logi użytkowników</h4>
          <!-- Pole wyszukiwania -->
          <input
            type="text"
            class="form-control form-control-sm"
            placeholder="Szukaj..."
            v-model="searchTerm"
            @input="onSearch"
            style="max-width: 250px"
          />
        </div>

        <div class="widget-content">
          <div class="table-responsive">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Data</th>
                  <th>Godzina</th>
                  <th>Login</th>
                  <th>Imię i Nazwisko</th>
                  <th>User ID</th>
                  <th>IP</th>
                  <th>Status logowania</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="log in logs.data" :key="log.id">
                  <td>{{ log.id }}</td>
                  <td>{{ log.created_at ? formatDate(log.created_at) : '-' }}</td>
                  <td>{{ log.created_at ? formatTime(log.created_at) : '-' }}</td>
                  <td>{{ log.login }}</td>
                  <td>{{ log.user ? log.user.first_name + ' ' + log.user.last_name : '-' }}</td>
                  <td>{{ log.user_id ?? '-' }}</td>
                  <td>{{ log.ip ?? '-' }}</td>
                  <td>{{ log.status == 1 ? 'Poprawne' : 'Niepoprawne' }}</td>
                </tr>
              </tbody>
            </table>

            <!-- Paginacja -->
            <div class="d-flex justify-content-between align-items-center mt-3 flex-wrap">
              <div class="mb-2">
                <button class="btn btn-outline-secondary btn-sm me-1" :disabled="logs.current_page <= 1" @click="goToPage(logs.current_page-1)">
                  « Poprzednia
                </button>

                <button
                  v-for="p in pageNumbers"
                  :key="p"
                  class="btn btn-sm me-1"
                  :class="p === logs.current_page ? 'btn-primary' : 'btn-outline-secondary'"
                  @click="goToPage(p)">
                  {{ p }}
                </button>

                <button class="btn btn-outline-secondary btn-sm" :disabled="logs.current_page >= logs.last_page" @click="goToPage(logs.current_page+1)">
                  Następna »
                </button>
              </div>

              <div class="mb-2">
                Strona {{ logs.current_page }} / {{ logs.last_page }} | Łącznie {{ logs.total }} rekordów
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import debounce from 'lodash/debounce'; // opcjonalnie dla wydajności

export default {
  props: {
    logs: Object,
    search: String
  },
  components: { AppLayout },
  data() {
    return {
      searchTerm: this.search || ''
    };
  },
  methods: {
    formatDate(datetime) {
      return new Date(datetime).toLocaleDateString();
    },
    formatTime(datetime) {
      return new Date(datetime).toLocaleTimeString();
    },
    goToPage(page) {
      if (page < 1 || page > this.logs.last_page) return;
      this.$inertia.get('/admin/users/logs', { page, search: this.searchTerm }, { preserveState: true, replace: true });
    },
    onSearch: debounce(function() {
      this.$inertia.get('/admin/users/logs', { search: this.searchTerm }, { preserveState: true, replace: true });
    }, 300), // opóźnienie, żeby nie wysyłać żądania przy każdym znaku
  },
  computed: {
    pageNumbers() {
      const numbers = [];
      const total = this.logs.last_page;
      let start = Math.max(this.logs.current_page - 2, 1);
      let end = Math.min(start + 4, total);
      for (let i = start; i <= end; i++) numbers.push(i);
      return numbers;
    }
  }
};
</script>